import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 46 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.6713 3.8627C20.719 0.638119 25.281 0.638122 26.3287 3.86271L28.8109 11.502C29.4133 13.3561 31.1411 14.6115 33.0906 14.6115H41.1231C44.5136 14.6115 45.9233 18.9501 43.1803 20.943L36.6819 25.6644C35.1047 26.8103 34.4448 28.8414 35.0472 30.6955L37.5294 38.3348C38.5771 41.5594 34.8864 44.2409 32.1434 42.248L25.645 37.5266C24.0678 36.3807 21.9322 36.3807 20.355 37.5266L13.8566 42.248C11.1136 44.2409 7.4229 41.5594 8.47063 38.3348L10.9528 30.6955C11.5552 28.8414 10.8953 26.8103 9.31807 25.6644L2.81967 20.943C0.0766754 18.9501 1.48639 14.6115 4.87693 14.6115H12.9094C14.8589 14.6115 16.5867 13.3561 17.1891 11.502L19.6713 3.8627Z",
      fill: "#56647D",
      stroke: "white"
    }, null, -1)
  ])))
}
export default { render: render }